interface ServiceCardProps {
  icon: string;
  title: string;
  description: string;
  features: string[];
}

export default function ServiceCard({ icon, title, description, features }: ServiceCardProps) {
  return (
    <div className="group bg-white rounded-xl p-8 shadow-md hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-red-600 cursor-pointer">
      <div className="w-16 h-16 bg-red-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-red-600 transition-colors duration-300">
        <i className={`${icon} text-3xl text-red-600 group-hover:text-white transition-colors duration-300`}></i>
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-3 font-poppins">{title}</h3>
      <p className="text-sm text-gray-600 mb-4 leading-relaxed font-inter">{description}</p>
      <ul className="space-y-2">
        {features.map((feature, index) => (
          <li key={index} className="flex items-center text-sm text-gray-700 font-inter">
            <i className="ri-check-line text-red-600 mr-2 text-lg"></i>
            {feature}
          </li>
        ))}
      </ul>
    </div>
  );
}
